import { queryOptions } from "@tanstack/react-query";
import { HiveSignerIntegration } from "../../hivesigner";
import { getBoundFetch, getQueryClient } from "@/modules/core";

export function getAccountTokenQueryOptions(
  username: string | undefined,
  accessToken: string | undefined
) {
  return queryOptions({
    queryKey: ["integrations", "3speak", "authenticate", username],
    enabled: !!username && !!accessToken,
    queryFn: async () => {
      if (!username || !accessToken) {
        throw new Error("[SDK][Integrations][3Speak] – anon user");
      }

      const fetchApi = getBoundFetch();
      const response = await fetchApi(
        `https://studio.3speak.tv/mobile/login?username=${username}&hivesigner=true`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const memoQueryOptions =
        HiveSignerIntegration.queries.getDecodeMemoQueryOptions(
          username,
          (await response.json()).memo,
          accessToken
        );
      await getQueryClient().prefetchQuery(memoQueryOptions);
      const { memoDecoded } = getQueryClient().getQueryData(
        memoQueryOptions.queryKey
      );

      return memoDecoded.replace("#", "");
    },
  });
}
